"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiconomyProvider = void 0;
const ethers_1 = require("ethers");
const __1 = require("..");
const util_1 = require("../../util");
const { Biconomy } = require("@biconomy/mexa");
class BiconomyProvider extends __1.HyphenProvider {
    constructor(params) {
        super(params.providerParams);
        this.getProviderWithAccounts = (useBiconomy) => {
            let result;
            if (this.walletProvider) {
                result = this.walletProvider;
            }
            else {
                result = this.getProvider(useBiconomy);
            }
            return result;
        };
        if (params.enableBiconomy && params.biconomyOptions) {
            const biconomyOptions = params.biconomyOptions;
            if (biconomyOptions && params.walletProvider) {
                biconomyOptions.walletProvider = params.walletProvider;
            }
            this.biconomy = new Biconomy(this.provider, biconomyOptions);
            this.biconomyProvider = new ethers_1.ethers.providers.Web3Provider(this.biconomy);
        }
        if (params.walletProvider) {
            if ((0, util_1.isEthersProvider)(params.walletProvider)) {
                throw new Error("Wallet Provider in options can't be an ethers provider. Please pass the provider you get from your wallet directly.");
            }
            this.walletProvider = new ethers_1.ethers.providers.Web3Provider(params.walletProvider);
        }
    }
    getBiconomy() {
        return this.biconomy;
    }
    getProvider(useBiconomy) {
        if (useBiconomy) {
            return this.biconomyProvider ? this.biconomyProvider : this.provider;
        }
        else {
            return this.provider;
        }
    }
}
exports.BiconomyProvider = BiconomyProvider;
